module.exports = __webpack_public_path__ + "static/img/1.229bf3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/fgimg/1.jpg
// module id = 1cAq
// module chunks = 18